module.exports = __webpack_public_path__ + "static/xena-public-private@3x-048afb621d9083ce2a9c0aada842f440.png";